import { SizeOptions } from '../types';
import { largeSpinner } from './animation/large__80x80_';
import { mediumSpinner } from './animation/medium__40x40_';
import { smallSpinner } from './animation/small__24x24_';
import { smallerSpinner } from './animation/smaller__16x16_';

export const getSpinnerJSON = (size?: SizeOptions): JSON => {
  switch (size) {
    case 'smaller':
      return JSON.parse(smallSpinner);
    case 'small':
      return JSON.parse(smallerSpinner);
    case 'large':
      return JSON.parse(largeSpinner);
    default:
      return JSON.parse(mediumSpinner);
  }
};
